module.exports = __webpack_public_path__ + "img/fl-ondevice.e895ce4a.jpg";